import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ gridColumnStart }) =>
  css({
    gridColumnStart,
    'p:nth-child(1)': {
      ml: 's',
      textAlign: 'start',
    },
    'p:nth-child(2)': {
      ml: 's',
    },
  }),
);

themeStyles.addBaseStyles('ColorName')(
  css({
    mb: 's',
  }),
);

export default themeStyles;
